import React from 'react';
import { Link } from 'react-router-dom';

const HomeFooter = () => {
  return (
    <footer className="bg-surface-container-lowest relative w-full py-16 px-12">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-7xl mx-auto">
        <div className="flex flex-col space-y-4">
          <Link to="/" className="font-headline italic text-xl text-primary">Migration Journal</Link>
          <p className="font-headline text-lg italic text-slate-300">Preservation through observation.</p>
          <div className="flex gap-4 mt-6">
            <span className="material-symbols-outlined text-slate-500 hover:text-on-surface cursor-pointer transition-colors">public</span>
            <span className="material-symbols-outlined text-slate-500 hover:text-on-surface cursor-pointer transition-colors">history_edu</span>
          </div>
          <p className="text-slate-600 text-[10px] mt-8 font-body">
            &copy; 2026 Digital Field Journal. Preservation through observation.
          </p>
        </div>
        <div className="flex flex-col space-y-4">
          <h5 className="text-slate-200 font-label text-xs uppercase tracking-widest mb-2">Resources</h5>
          <Link to="/explorer" className="text-slate-500 font-label text-xs uppercase tracking-widest hover:text-on-surface transition-colors">
            Migration Explorer
          </Link>
          <Link to="/sources" className="text-slate-500 font-label text-xs uppercase tracking-widest hover:text-on-surface transition-colors">
            Data Sources &amp; Credits
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default HomeFooter;
